// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'fc07634852050aecdd6eb700c3cac3122390ebac';
export const BUILD_NUMBER = '184';
export const BUILD_TIMESTAMP = '2026-07-01T23:52:53.422Z';
